import { render, staticRenderFns } from "./CheckCartSaveTrModal.vue?vue&type=template&id=2b4825a6&scoped=true"
import script from "./checkCartSaveTrModal.ts?vue&type=script&lang=ts&external"
export * from "./checkCartSaveTrModal.ts?vue&type=script&lang=ts&external"
import style0 from "./CheckCartSaveTrModal.vue?vue&type=style&index=0&id=2b4825a6&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2b4825a6",
  null
  
)

export default component.exports